import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { isDeleteDialogOpenLoadingSelector, isDeleteDialogOpenSelector } from './selectors'
import { setDeleteDialogOpen } from './slice'
import { destroySamlSsoSettings } from './thunks'

export const ConfirmDeleteDialog = () => {
  const dispatch = useDispatch()

  const isDialogOpen = useSelector(isDeleteDialogOpenSelector)
  const isLoading = useSelector(isDeleteDialogOpenLoadingSelector)

  const onConfirm = () => {
    dispatch(destroySamlSsoSettings())
  }

  const onClose = () => {
    dispatch(setDeleteDialogOpen(false))
  }

  return (
    <Popup
      title={I18n.t('publisher.organization_settings.sso.destroy_modal.title')}
      isOpen={isDialogOpen}
      onClose={() => {}}
    >
      <Body>
        <p>
          {I18n.t('publisher.organization_settings.sso.destroy_modal.login_warning')}
        </p>
        <br />
        <p>
          {I18n.t('publisher.organization_settings.sso.destroy_modal.delete_warning')}
        </p>
      </Body>
      <Footer>
        <Button
          onClick={onClose}
          disabled={isLoading}
          decoration="secondary-outline"
        >
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          {I18n.t('publisher.action.yes')}
        </Button>
      </Footer>
    </Popup>
  )
}
